<div class="filter-component-container">

    <div class="filter-component-main container-with-select">

        <mat-form-field>
            <input matInput autocomplete="off" type="numeric" placeholder="Número de dias sem uso"
                [(ngModel)]="diasUltSessao" inputmode="numeric">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Situação atual</mat-label>
            <mat-radio-group>
                <mat-select placeholder="Situação Atual" [(ngModel)]="statusAtual">
                    <mat-option [value]="''">Todas</mat-option>
                    <mat-option [value]="'Contrato vigente'">Contrato vigente</mat-option>
                    <mat-option [value]="'Contrato expirado'">Contrato expirado</mat-option>
                </mat-select>
            </mat-radio-group>
        </mat-form-field>

        <div class="corretora-field-app-origem">
            <mat-form-field>
                <mat-label>Aplicação origem</mat-label>
                <mat-select [value]="''" placeholder="Aplicação origem" [(ngModel)]="appOrigemModel" name="appOrigem">
                    <mat-option [value]="''">Todas</mat-option>
                    <mat-option *ngFor="let app of appOrigem; let i = index" [value]="app.id">     
                        {{ app.nome }}
                    </mat-option>           
                </mat-select>
            </mat-form-field>
        </div>

    </div>
</div>